// Native
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Imported
import { InlineSVGModule } from 'ng-inline-svg';
import { ToastrModule } from 'ngx-toastr';
import { NgxPopperModule, PopperContentOptions } from 'ngx-popper';

// Configs
import { PopperConfig } from './configs/popper.config';

// Components
import { AppComponent } from './app.component';
import { PageTopModule } from './resources/components/page-top/page-top.module';
import { SidebarModule } from './resources/components/sidebar/sidebar.module';

// Modules
import { GuardsModule } from './resources/guards/guards.module';
import { PagesModule } from './pages/pages.module';
import { SharedModule } from './modules/shared.module';
import {RouterModule} from '@angular/router';
import {BreadcrumbsModule} from "./resources/modules/breadcrumbs/breadcrumbs.module";
import { RouterOutletComponent } from './resources/components/router-outlet/router-outlet.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {MonacoEditorModule} from 'ngx-monaco-editor';

@NgModule({
  declarations: [
    AppComponent,
    RouterOutletComponent,
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    InlineSVGModule.forRoot({baseUrl: '/assets/images/'}),
    ToastrModule.forRoot(),
    NgxPopperModule.forRoot(PopperConfig.default as PopperContentOptions),
    PagesModule,
    RouterModule,
    PageTopModule,
    SidebarModule,
    GuardsModule,
    SharedModule,
    BreadcrumbsModule,
    MonacoEditorModule.forRoot()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
